import { Box, Divider, Stack } from '@mui/material'
import VerifyOrderPdf from '../verify-order-pdf/verify-order-pdf'
import VerifyOrderForm from '../verify-order-form/verify-order-form'
import { useSelector } from 'react-redux'
import { RootState } from 'store'

interface IProps {
  pdfUrl: string
  onClose?: () => void
}

const VerifyOrderMobile = ({ pdfUrl, onClose }: IProps) => {
  const selectedOrder = useSelector(
    (state: RootState) => state.orders.selectedOrder
  )

  return (
    <Box px={1} pt={1} sx={{ height: '100%', overflow: 'auto', pr: 5 }}>
      <Stack spacing={1}>
        <VerifyOrderPdf pdfUrl={pdfUrl} />
        <Divider sx={{ bgcolor: 'secondary.main' }} />
        <VerifyOrderForm order={selectedOrder} onClose={onClose} />
      </Stack>
    </Box>
  )
}

export default VerifyOrderMobile
